import { Notify } from '~/components2/Notify';
import { ccRecipientsNotice } from '~/components2/SendEmailModal';

const EXPORT_QUEUED_TOAST_DURATION_MS = 7_000;

type ExportQueuedToast = Omit<Parameters<typeof Notify.info>[0], 'message'> & {
  message: string;
  ccEmails?: string[];
};

export function notifyExportQueued({
  ccEmails,
  message,
  duration = EXPORT_QUEUED_TOAST_DURATION_MS,
  ...toast
}: ExportQueuedToast) {
  Notify.info({ ...toast, message: `${message}${ccRecipientsNotice(ccEmails)}`, duration });
}
